import { Fetcher } from '../../../common/api';
import { StringUtils } from '../../../common/utils/string';
import { IPerson } from '../../../person';
import { endpoints } from '../../api/endpoints';
import { PaymentErr, errorFactory } from '../../errors/payment/errors';

export const deleteCard = async (
  fetcher: Fetcher,
  cardId: string,
): Promise<IPerson> => {
  try {
    const response = await fetcher.delete<IPerson>(
      StringUtils.bindContext(endpoints.DELETE_CARD, {
        id: cardId,
      }),
    );
    return response.data;
  } catch (error) {
    throw errorFactory.create(PaymentErr.DELETE_CARD_FAILED);
  }
};
